import React, {Component} from 'react';

import helpers from "../../../../utils/helpers";

export default class ProductView extends Component {

    render() {

        let product = this.props.item;
        if(!product){return <div />}
        let tripFE = this.props.item.trip_type === helpers.trip_type.FE;

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>{product.name}</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Código</label>
                        <p className={"field-p"}>{product.code}</p>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Tipo de viajes</label>
                        <p className={"field-p"}>{product.trip_type === helpers.trip_type.FE ? 'Fame & Ethanol' : 'Cargas Generales'}</p>
                    </div>
                </div>
                {tripFE &&
                <div className={"row"}>
                    <div className={"col s6 input-field"}>
                        <label className="active">Tolerancia de volumen</label>
                        <p className={"field-p"}>{product.volume_tolerance}</p>
                    </div>
                    <div className={"col s6 input-field"}>
                        <label className="active">Tolerancia de peso</label>
                        <p className={"field-p"}>{product.weight_tolerance}</p>
                    </div>
                </div>
                }
                {tripFE &&
                <div className={"row"}>
                    <div className={"col s6 input-field"}>
                        <label className="active">Tolerancia de densidad</label>
                        <p className={"field-p"}>{product.density_tolerance}</p>
                    </div>
                    {tripFE && product.check_alcohol &&
                    <div className={"col s6 input-field"}>
                        <label className="active">Tolerancia alcoholica</label>
                        <p className={"field-p"}>{product.alcoholic_grade_tolerance}</p>
                    </div>
                    }
                </div>
                }
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={"btn btn-shell-empty z-depth-0"}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={"btn btn-shell z-depth-0"}
                            onClick={() => this.props.editAction(product, 'edit')}
                        >Editar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/ProductView.js